import { z } from "zod";

export const updateExhibitorInspectorSchema = z.object({
  connectId: z
    .string()
    .min(10, "L'identifiant doit contenir au moins 10 caractères"),
  clearPassword: z
    .string()
    .min(8, "Le mot de passe doit contenir au moins 8 caractères"),
});

export type UpdateExhibitorInspectorForm = z.infer<
  typeof updateExhibitorInspectorSchema
>;

export const defaultUpdateExhibitorInspectorValues: UpdateExhibitorInspectorForm =
  {
    connectId: "",
    clearPassword: "",
  };
